// Read-only or trainer-interactive game review history panel.
import { MoveHistory } from '../MoveHistory';
import type { Color, RoomState } from '../../types';

type HistoryEntries = RoomState['history'];

function firstMoveColor(entries: HistoryEntries): Color {
  const nextTurn = entries[0]?.fen.split(/\s+/)[1];
  return nextTurn === 'w' ? 'b' : 'w';
}

type ReviewHistoryPanelProps = {
  entries: HistoryEntries;
  interactive?: boolean;
  onSelect?: (entry: HistoryEntries[number], index: number) => void;
};

export function ReviewHistoryPanel({ entries, interactive = false, onSelect }: ReviewHistoryPanelProps) {
  return (
    <section className="panel">
      <h2>Разбор партии</h2>
      <MoveHistory
        entries={entries}
        firstMoveColor={firstMoveColor(entries)}
        interactive={interactive}
        onSelect={onSelect}
      />
    </section>
  );
}
